const range = (start, end) => new Array(end - start).fill(start).map((el, i) => start + i);
var penjualan = [2680, 2777, 1289, 1222, 1133, 1441, 2680, 2777, 1289, 1222, 1133, 1441];
var pengeluaran = 1500000;

const shortMonth = [
  'Jul 2018', 'Aug 2018', 'Sep 2018', 'Oct 2018', 'Nov 2018', 'Dec 2018',
  'Jan 2019', 'Feb 2019', 'Mar 2019', 'Apr 2019', 'May 2019', 'Jun 2019'
];

// const monthVisitData = shortMonth.map(m => {  
//   return {
//     'month': m,
//     'Penjualan': [penjualan],
//     'Pengeluaran': Math.floor(pengeluaran/(Math.random())),
//   };
// });

const monthVisitData = [
  {
    'Month': 'Jul 2018',
    'Penjualan (Kg)': '325',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Aug 2018',
    'Penjualan (Kg)': '265',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Sep 2018',
    'Penjualan (Kg)': '445',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Oct 2018',
    'Penjualan (Kg)': '155',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Nov 2018',
    'Penjualan (Kg)': '520',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Dec 2018',
    'Penjualan (Kg)': '155',
    // 'Harga Pemasukan (Rp)': '2000',
  },

  {
    'Month': 'Jan 2019',
    'Penjualan (Kg)': '125',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Feb 2019',
    'Penjualan (Kg)': '120',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Mar 2019',
    'Penjualan (Kg)': '140',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Apr 2019',
    'Penjualan (Kg)': '225',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'May 2019',
    'Penjualan (Kg)': '105',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Jun 2019',
    'Penjualan (Kg)': '100',
    // 'Harga Pemasukan (Rp)': '2000',
  },
];

const pemasukanData = [
  {
    'Month': 'Jul 2018',
    'Total Pemasukan (Rp)': '2000000',
  },
  {
    'Month': 'Aug 2018',
    'Total Pemasukan (Rp)': '500000',
  },
  {
    'Month': 'Sep 2018',
    'Total Pemasukan (Rp)': '800000',
  },
  {
    'Month': 'Oct 2018',
    'Total Pemasukan (Rp)': '700000',
  },
  {
    'Month': 'Nov 2018',
    'Total Pemasukan (Rp)': '1200000',
  },
  {
    'Month': 'Dec 2018',
    'Total Pemasukan (Rp)': '1500000',
  },

  {
    'Month': 'Jan 2019',
    'Total Pemasukan (Rp)': '1300000',
  },
  {
    'Month': 'Feb 2019',
    'Total Pemasukan (Rp)': '1600000',
  },
  {
    'Month': 'Mar 2019',
    'Total Pemasukan (Rp)': '1200000',
  },
  {
    'Month': 'Apr 2019',
    'Total Pemasukan (Rp)': '900000',
  },
  {
    'Month': 'May 2019',
    'Total Pemasukan (Rp)': '1300000',
  },
  {
    'Month': 'Jun 2019',
    'Total Pemasukan (Rp)': '1500000',
  },
];

const campaignData = [
  {
    value: 335,
    name: 'Kayu Sengon'
  },
  {
    value: 455,
    name: 'Jambu Kristal'
  },
  {
    value: 655,
    name: 'Cabai Rawit'
  },
  {
    value: 135,
    name: 'Kayu Jabon'
  },
  {
    value: 1548,
    name: 'Kopi'
  },
  {
    value: 215,
    name: 'Kapulaga'
  },
  {
    value: 365,
    name: 'Jagung'
  },
  {
    value: 520,
    name: 'Jeruk'
  }
];

const monthVisitData2 = [
  {
    'Month': 'Jul 2018',
    'Penjualan (Kg)': '325',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Aug 2018',
    'Penjualan (Kg)': '265',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Sep 2018',
    'Penjualan (Kg)': '445',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Oct 2018',
    'Penjualan (Kg)': '155',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Nov 2018',
    'Penjualan (Kg)': '520',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Dec 2018',
    'Penjualan (Kg)': '155',
    // 'Harga Pemasukan (Rp)': '2000',
  },

  {
    'Month': 'Jan 2019',
    'Penjualan (Kg)': '125',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Feb 2019',
    'Penjualan (Kg)': '120',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Mar 2019',
    'Penjualan (Kg)': '140',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Apr 2019',
    'Penjualan (Kg)': '225',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'May 2019',
    'Penjualan (Kg)': '105',
    // 'Harga Pemasukan (Rp)': '2000',
  },
  {
    'Month': 'Jun 2019',
    'Penjualan (Kg)': '100',
    // 'Harga Pemasukan (Rp)': '2000',
  },
];

const pemasukanData2 = [
  {
    'Month': 'Jul 2018',
    'Harga Jual (Rp)': '1500000',
  },
  {
    'Month': 'Aug 2018',
    'Harga Jual (Rp)': '1250000',
  },
  {
    'Month': 'Sep 2018',
    'Harga Jual (Rp)': '900000',
  },
  {
    'Month': 'Oct 2018',
    'Harga Jual (Rp)': '500000',
  },
  {
    'Month': 'Nov 2018',
    'Harga Jual (Rp)': '1750000',
  },
  {
    'Month': 'Dec 2018',
    'Harga Jual (Rp)': '2250000',
  },

  {
    'Month': 'Jan 2019',
    'Harga Jual (Rp)': '1850000',
  },
  {
    'Month': 'Feb 2019',
    'Harga Jual (Rp)': '2150000',
  },
  {
    'Month': 'Mar 2019',
    'Harga Jual (Rp)': '1350000',
  },
  {
    'Month': 'Apr 2019',
    'Harga Jual (Rp)': '2500000',
  },
  {
    'Month': 'May 2019',
    'Harga Jual (Rp)': '2250000',
  },
  {
    'Month': 'Jun 2019',
    'Harga Jual (Rp)': '1900000',
  },
];

const campaignData2 = [
  {
    value: 325,
    name: 'Kayu Sengon'
  },
  {
    value: 335,
    name: 'Jambu Kristal'
  },
  {
    value: 540,
    name: 'Cabai Rawit'
  },
  {
    value: 125,
    name: 'Kayu Jabon'
  },
  {
    value: 380,
    name: 'Kopi'
  },
  {
    value: 455,
    name: 'Kapulaga'
  },
  {
    value: 365,
    name: 'Jagung'
  },
  {
    value: 640,
    name: 'Jeruk'
  }
];

const locationData = [
  {
    value: Math.floor((1600000*40)/100),
    name: 'Bayaran Tutor'
  },
  {
    value: Math.floor((1600000*12)/100),
    name: 'Operasional'
  },
  {
    value: Math.floor((1600000*15)/100),
    name: 'Promosi'
  },
  {
    value: Math.floor((1600000*10)/100),
    name: 'Marketing'
  },
  {
    value: Math.floor((1600000*18)/100),
    name: 'Lainnya'
  }
];

const StackMainData = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
const StackData = StackMainData.map((item, key) => {
  return {
    'label': key + 'D',
    'max': 500,
    'sales': item,
  };
});   
const SinData = range(1, 12).map(i => {
  return {
    'cate': 'Cat' + i,
    'value': ((Math.sin(i / 5) * (i / 5 - 0.1) + i / 6) * 5)
  };
});


export {
  monthVisitData,
  pemasukanData,
  campaignData,
  monthVisitData2,
  pemasukanData2,
  campaignData2,
  locationData,
  StackData,
  SinData,
};